import React, { useState } from 'react';
import axios from 'axios';

const BASE_URL =
	window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

const ResendEmailPage = ({ email }) => {
	const [status, setStatus] = useState('');
	const [resending, setResending] = useState(false);

	const handleResend = async () => {
		setResending(true);
		setStatus('');
		try {
			const res = await axios.post(
				`${BASE_URL}/api/auth/resend-verification`,
				{ email },
				{
					headers: { 'Content-Type': 'application/json' },
				}
			);
			if (res.data.success) {
				setStatus('Verification email resent to ' + email);
			} else {
				setStatus(res.data.message || 'Failed to resend email');
			}
		} catch (err) {
			setStatus(err.response?.data?.message || err.message || 'Failed to resend email');
		} finally {
			setResending(false);
		}
	};

	return (
		<div style={{ textAlign: 'center', marginTop: 60 }}>
			<h2>Email Verification</h2>
			<p>Please check your inbox for a verification email.</p>
			<p>If you did not receive the email, click below to resend:</p>
      <br />
     	<button
				onClick={handleResend}
				disabled={resending}
				style={{
					padding: '10px 30px',
					fontSize: '1rem',
					backgroundColor: '#FF5C36',
					color: '#fff',
					border: 'none',
					borderRadius: '5px',
					cursor: 'pointer',
				}}>
				{resending ? 'Resending...' : 'Resend Verification Email'}
			</button>
			{status && <div style={{ color: status.includes('resent') ? 'green' : 'red', marginTop: 20 }}>{status}</div>}
      <br />
      <br />
      <p>Note: Please check your spam or junk folder if the verification email doesn’t appear in your inbox. </p>
		</div>
	);
};

export default ResendEmailPage;
